/** The pick, and how many of its rows were resolved, the last time ancestors were expanded. */
export type BulkExpandMark = { version: number; pathCount: number };

/**
 * Whether a tree update should expand ancestors for the active viewer pick.
 *
 * Ancestors load asynchronously, so one pick's rows resolve across several tree updates:
 * the primary row is usually in the tree immediately, while box/lasso rows appear only once
 * `useLoadAncestorsForSelection` has fetched their chains. Expanding whenever the resolved
 * count grows lets each batch expand once, while a user's own collapse is left alone —
 * collapsing a row doesn't change how many selected ids resolve to paths.
 */
export function shouldExpandForBulkPick(last: BulkExpandMark, version: number, pathCount: number): boolean {
    return last.version !== version || pathCount > last.pathCount;
}

/** Next expand mark when {@link shouldExpandForBulkPick} is true; otherwise leave the last mark alone. */
export function nextBulkExpandMark(
    last: BulkExpandMark,
    version: number,
    pathCount: number,
): BulkExpandMark | undefined {
    if (!shouldExpandForBulkPick(last, version, pathCount)) {
        return undefined;
    }
    return { version, pathCount };
}
